import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';

export default function DashboardRedirect() {
  const me = useQuery(api.me.get);
  const navigate = useNavigate();

  useEffect(() => {
    // undefined = still loading, null = no user record in Convex DB
    if (me === undefined) return;

    if (me === null) {
      // User is authenticated in Clerk but not in Convex DB
      // Redirect to bootstrap to create their record
      navigate('/bootstrap', { replace: true });
      return;
    }

    const roles = me.roles;

    // Redirect based on primary role (priority: director > coach > parent)
    if (roles.includes('director')) {
      navigate('/director', { replace: true });
    } else if (roles.includes('coach')) {
      navigate('/coach', { replace: true });
    } else if (roles.includes('parent')) {
      navigate('/parent', { replace: true });
    } else {
      // User exists but has no roles - this shouldn't happen
      navigate('/unauthorized', { replace: true });
    }
  }, [me, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p>Redirecting to your dashboard...</p>
    </div>
  );
}
